import {
    PlatformStorage,
    PlatformStorageKeysEnum,
} from "@core/data/infrastructures/storage/storage.ts";
import type { Nullable } from "@core/domain/types/nullable.type";
import type { ObjectLike } from "@core/domain/types/object-like.type";
import { injectable } from "inversify";

@injectable()
export class LocalStorage implements PlatformStorage {
    get(key: PlatformStorageKeysEnum): Nullable<string> {
        return localStorage.getItem(key);
    }

    getObject<T extends ObjectLike<T> = Record<string, unknown>>(
        key: PlatformStorageKeysEnum,
    ): Nullable<T> {
        const value = this.get(key);

        if (value === null) return value;

        try {
            return JSON.parse(value) as T;
        } catch (error: unknown) {
            if (error instanceof SyntaxError) {
                console.error(error.message);
            }
            return null;
        }
    }

    set(key: PlatformStorageKeysEnum, value: string): void {
        localStorage.setItem(key, value);
    }

    setObject(
        key: PlatformStorageKeysEnum,
        value: Record<string, unknown>,
    ): void {
        this.set(key, JSON.stringify(value));
    }

    remove(key: PlatformStorageKeysEnum): void {
        localStorage.removeItem(key);
    }
}
